import { FONT, FontStyleSheet } from '../font-style-sheets';
import { PrintCardMenu } from './print-card-menu';

export class FikaAccessoriesPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.NeueHaasGroteskDisplay.Regular_400,
      FONT.NeueHaasGroteskDisplay.Medium_500,
      FONT.NeueHaasGroteskDisplay.SemiBold_600,
      FONT.NeueHaasGroteskDisplay.Bold_700
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/wxq6frp.css';
  }

  shouldStandardizeDominantStrainType(): boolean {
    return false;
  }
}
